import RequireAuth from "../components/routing/RequireAuth";

export const protectRoutes = (routes) =>
  routes.map((route) => ({
    ...route,
    element: <RequireAuth>{route.element}</RequireAuth>,
  }));
